import { Component, EventEmitter, Input, Optional, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal",
  standalone: true,
  imports: [],
  templateUrl: "./modal.component.html",
  styleUrl: "./modal.component.scss",
})
export class ModalComponent {
  @Output() modalClose = new EventEmitter<string>();

  @Input() set activeModalInput(modal: NgbActiveModal) {
    if (modal) this.activeModal = modal;
  }

  constructor(@Optional() public activeModal: NgbActiveModal) {}

  closeModal(value: any) {
    if (this.modalClose.observed) {
      this.modalClose.emit(value);
    } else {
      this.activeModal?.close(value);
    }
  }
}
